import React from "react";
import ReactECharts from "echarts-for-react";
import { Box } from "@mui/material";

const STATUS_COLORS = {
  Converted: "#4CAF50",
  "Not Converted": "#FF5252",
  "Follow-up Required": "#FFC881",
};

const ConversionStatus = ({ cardDetails, onStatusClick }) => {
  const outcomeData = cardDetails?.outcomeCount || {};

  const data = Object.entries(outcomeData).filter(([name]) => name !== "N/A").map(([name, value]) => ({
    name,
    value,
    itemStyle: {
      color: STATUS_COLORS[name] || "#BDBDBD",
    },
  }));

  const noData = data.length === 0 || data.every(d => d.value === 0);

  const option = {
    title: {
      text: "Conversion Status",
      left: "left",
      textStyle: {
        fontSize: 14,
        fontWeight: 700,
        color: "#464646",
      },
    },
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c} ({d}%)",
    },
    legend: {
      bottom: 0,
      left: "center",
    },
    series: [
      {
        name: "Conversion Status",
        type: "pie",
        radius: ["45%", "70%"],
        center: ["50%", "50%"],
        padAngle: 4,
        itemStyle: {
          borderRadius: 8,
        },
        label: {
          formatter: "{b}: {c}",
          fontSize: 13,
          fontWeight: 600,
        },
        data,
      },
    ],
  };

  const onEvents = {
    click: (params) => {
      if (params?.name && onStatusClick) {
        onStatusClick(params.name);
      }
    },
  };


  return (
    <Box sx={{ height: "50vh", width: "100%" }}>
      {!noData ? (
        <ReactECharts option={option} style={{ height: "100%" }} opts={{ renderer: "svg" }} onEvents={onEvents} />
      ) : (
        <Box
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          color="#999"
          fontWeight={600}
        >
          No data available
        </Box>
      )}
    </Box>
  );
};

export default ConversionStatus;
